// import React, { useEffect, useState } from 'react';
// import { ArrowLeftOutlined } from '@ant-design/icons';
// import logo from '../img/Llogo.png'; // Update with your logo path
// import { useNavigate } from 'react-router-dom';

// const NotificationWeb = () => {
//   const navigate = useNavigate();
  // const [notifications, setNotifications] = useState([]);
  // const [fullNotification, setFullNotification] = useState(null);
  // const dist = sessionStorage.getItem('dist') || '320E';

  // useEffect(() => {
  //   fetch(`https://lionsdirectoryapi.emedha.in/get/notification?dist=${dist}`)
  //     .then(res => res.json())
  //     .then(data => setNotifications(data))
  //     .catch(err => console.error(err));
  // }, [dist]);

  // const fetchFullNotification = async (id) => {
  //   try {
  //     const res = await fetch('https://lionsdirectoryapi.emedha.in/full/notification', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ id })
  //     });
  //     const data = await res.json();
  //     setFullNotification(data[0]); // assuming only 1 object in full data
  //   } catch (err) {
  //     console.error('Error loading full message', err);
  //   }
  // };

//   return (
//     <div style={{
//       width: '365px',
//       minHeight: '557px',
//       maxHeight: '667px',
//       margin: '10px auto',
//       border: '1px solid #ccc',
//       borderRadius: '20px',
//       overflow: 'hidden',
//       boxShadow: '0 0 10px rgba(0,0,0,0.2)',
//       backgroundColor: '#f8f9fa',
//       display: 'flex',
//       flexDirection: 'column',
//       padding: 10
//     }}>
      
//       {/* Header */}
//       <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
//         <ArrowLeftOutlined
//           style={{ fontSize: '18px', color: '#0e3972', cursor: 'pointer', marginRight: '10px' }}
//           onClick={() => navigate('/home')}
//         />
//         <h6 style={{ color: '#0e3972', fontWeight: 'bold', margin: 0 }}>Notifications</h6>
//       </div>

//       <div style={{ overflowY: 'auto', maxHeight: '530px', paddingRight: 4 }}>
//         {!fullNotification ? (
//           notifications.map((n) => (
//             <div
//               key={n.sno}
//               onClick={() => fetchFullNotification(n.sno)}
//               style={{
//                 backgroundColor: '#fff',
//                 borderRadius: 8,
//                 marginBottom: 15,
//                 padding: 10,
//                 display: 'flex',
//                 gap: 10,
//                 alignItems: 'center',
//                 border: '2px solid #fff',
//                 boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
//                 cursor: 'pointer'
//               }}
//             >
//               <div style={{
//                 height: 60,
//                 width: 60,
//                 borderRadius: 30,
//                 backgroundColor: 'rgb(14, 57, 114)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}>
//                 <img src={logo} alt="logo" style={{ height: 36, width: 36, borderRadius: 18 }} />
//               </div>
//               <div>
//                 <div style={{ fontWeight: 'bold', fontSize: 18, color: 'rgb(14, 57, 114)' }}>{n.title}</div>
//                 <div style={{ fontSize: 15, color: 'orange', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '220px' }}>{n.message}</div>
//                 <div style={{ fontSize: 14, color: 'orange' }}>{n.dtime}</div>
//               </div>
//             </div>
//           ))
//         ) : (
//           <div>
//             <div onClick={() => setFullNotification(null)} style={{ textAlign: 'right', cursor: 'pointer', fontSize: 18, color: 'rgb(14, 57, 114)' }}>× Close</div>
//             <div style={{
//               backgroundColor: '#fff',
//               borderRadius: 8,
//               padding: 20,
//               display: 'flex',
//               gap: 10,
//               alignItems: 'center',
//               border: '2px solid #fff',
//               boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
//               flexDirection: 'column',
//               textAlign: 'center'
//             }}>
//               <div style={{
//                 height: 60,
//                 width: 60,
//                 borderRadius: 30,
//                 backgroundColor: 'rgb(14, 57, 114)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}>
//                 <img src={logo} alt="logo" style={{ height: 36, width: 36, borderRadius: 18 }} />
//               </div>
//               <div style={{ fontWeight: 'bold', fontSize: 20, color: 'rgb(14, 57, 114)', marginTop: 8 }}>{fullNotification.title}</div>
//               <div style={{ fontSize: 16, color: 'orange', fontWeight: 600, marginTop: 10 }}>{fullNotification.message}</div>
//               <div style={{ fontSize: 14, color: 'orange', marginTop: 10 }}>{fullNotification.dtime}</div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default NotificationWeb;


import React, { useEffect, useState } from 'react';
import { ChevronLeft, Bell, Clock } from 'lucide-react';

const NotificationWeb = ({ onBack, styles }) => {
  // Data structure focused on Title, Message, and Date
  const [notifications, setNotifications] = useState([]);
  const [fullNotification, setFullNotification] = useState(null);
  const dist = sessionStorage.getItem('dist') || '320E';

  useEffect(() => {
    fetch(`https://lionsdirectoryapi.emedha.in/get/notification?dist=${dist}`)
      .then(res => res.json())
      .then(data => setNotifications(data))
      .catch(err => console.error(err));
  }, [dist]);

  // const fetchFullNotification = async (id) => {
  //   try {
  //     const res = await fetch('https://lionsdirectoryapi.emedha.in/full/notification', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ id })
  //     });
  //     const data = await res.json();
  //     setFullNotification(data[0]); // assuming only 1 object in full data
  //   } catch (err) {
  //     console.error('Error loading full message', err);
  //   }
  // };

  return (
    <div style={styles.scrollArea}>
      {/* Navigation Header */}
      <div 
        onClick={onBack} 
        style={{ padding: '15px 15px 5px', display: 'flex', alignItems: 'center', color: '#0033A0', cursor: 'pointer' }}
      >
        <ChevronLeft size={20} />
        <span style={{ fontSize: '14px', fontWeight: '600' }}>Back to Home</span>
      </div>

      {/* Page Title Section */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', padding: '10px 15px 20px' }}>
        <div style={{ 
          backgroundColor: '#FFC20E', color: 'white', width: '45px', height: '45px', 
          borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' 
        }}>
          <Bell size={24} />
        </div>
        <h1 style={{ fontSize: '24px', color: '#0033A0', margin: 0 }}>Notifications</h1>
      </div>

      {/* Notifications List */}
      <div style={{ padding: '0 15px' }}>
        {notifications.map((note, index) => (
          <div key={index} style={{
            backgroundColor: 'white', 
            borderRadius: '12px', 
            padding: '18px',
            marginBottom: '12px', 
            border: note.unread ? '2px solid #FFC20E' : '1px solid #eee', 
            boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
            position: 'relative'
          }}>
            {/* Unread Indicator Dot */}
            {note.unread && (
              <div style={{
                position: 'absolute', right: '18px', top: '22px',
                width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#FFC20E'
              }} />
            )}

            {/* Title */}
            <h3 style={{ 
              margin: '0 0 8px 0', 
              fontSize: '16px', 
              color: '#000', 
              fontWeight: 'bold', 
              paddingRight: '20px' 
            }}>
              {note.title}
            </h3>

            {/* Message */}
            <p style={{ 
              margin: '0 0 12px 0', 
              fontSize: '14px', 
              color: '#666', 
              lineHeight: '1.4' 
            }}>
              {note.message}
            </p>

            {/* Date/Time */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#999' }}>
              <Clock size={14} />
              <span style={{ fontSize: '12px' }}>{note.dtime}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationWeb;
